import { RatingRemarkComponent } from './../../components/rating-remark/rating-remark.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { SecondHandSuppliesOrders } from '../../models/second-hand-supplies-orders';
import { GetSecondHandSuppliesOrdersByPkService } from '../../services/get-second-hand-supplies-orders-by-pk.service';
import { MatDialog } from '@angular/material/dialog';
import { CancelOrderComponent } from '../../components/cancel-order/cancel-order.component';
import { CancelOrderItemComponent } from '../../components/cancel-order-item/cancel-order-item.component';
import { RaiseSupportComponent } from '../../components/raise-support/raise-support.component';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'app-pre-owned-orders-details',
  templateUrl: './pre-owned-orders-details.component.html',
  styleUrls: ['./pre-owned-orders-details.component.scss'],
  animations: [
    trigger("openCloseStatus", [
      state('true', style({ height: '*', opacity: '1' })),
      state('false', style({ height: '160px', opacity: '1' })),
      transition("false <=> true", [animate(500)])
    ])
  ],
})
export class PreOwnedOrdersDetailsComponent implements OnInit {
  oldSecondHandSuppliesOrders: SecondHandSuppliesOrders;
  openStatus = false;
  constructor(
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private getSecondHandSuppliesOrdersByPkService: GetSecondHandSuppliesOrdersByPkService
  ) { }

  ngOnInit(): void {
    if(this.route.snapshot.data && this.route.snapshot.data.oldSecondHandSuppliesOrders){
      this.oldSecondHandSuppliesOrders = this.route.snapshot.data.oldSecondHandSuppliesOrders;
      this.getLatestOrderData();
    }
  }
  cancelOrder() {
    const dialogRef = this.dialog.open ( CancelOrderComponent, {
      width: '30%',
      panelClass:'custom-modal',
      data: this.oldSecondHandSuppliesOrders
    });
    dialogRef.afterClosed().subscribe(data=>{
      if(data === 'yes'){
        this.getLatestOrderData();
      }
    })
  }

  getLatestOrderData(){
    this.getSecondHandSuppliesOrdersByPkService.getSecondHandSuppliesOrdersByPk(this.oldSecondHandSuppliesOrders.id).subscribe(data=>{
      this.oldSecondHandSuppliesOrders = data;
    })
  }

  sendRatingReviewDialog(orderItem: any){
    const dialogRef = this.dialog.open ( RatingRemarkComponent, {
      width: '50%',
      panelClass:'custom-modal',
      data: orderItem
    });
    dialogRef.afterClosed().subscribe(data=>{
      if(data === 'yes'){
        this.getLatestOrderData();
      }
    })
  }

  cancelOrderOrderItemDialog(item_id: string) {
    const dialogRef = this.dialog.open ( CancelOrderItemComponent, {
      width: '30%',
      panelClass:'custom-modal',
      data: { item_id, supplies_order_id: this.oldSecondHandSuppliesOrders.id }
    });
    dialogRef.afterClosed().subscribe(data=>{
      if(data === 'yes'){
        this.getLatestOrderData();
      }
    })
  }

  supportRequestDialog(){
    const dialogRef = this.dialog.open ( RaiseSupportComponent, {
      width: '30%',
      panelClass:'custom-modal',
      data: {
        ...this.oldSecondHandSuppliesOrders,
        type: "SUPPLIER",
        order_type: "SECOND_HAND_SUPPLY"}
    });
    dialogRef.afterClosed().subscribe(data=>{
      if(data === 'yes'){
        this.getLatestOrderData();
      }
    })
  }
  filterToggleStatus(): void {
    this.openStatus = !this.openStatus;
  }
  viewInvoice(){
    window.open(`https://dental-360.herokuapp.com/api/v1/event/get-secondhand-invoice/${this.oldSecondHandSuppliesOrders.id}`);
  }
}

